import { DYNAMIC_CATEGORIES } from 'js/app/components/main/Games/constants';
import { useGamesSelector } from 'js/app/components/main/Games/store/context';

export const useIsAllCategories = () => {
    const { activeCategory } = useGamesSelector();

    return activeCategory.name === DYNAMIC_CATEGORIES.ALL_CATEGORY;
};
